module.exports = __webpack_public_path__ + "static/04-1ea356b50809ee090cf4f58a22ecd91c.jpg";